import { LitElement, html } from "lit-element";
import WebMidi from "webmidi";
import colorConvert, { rgb } from "color-convert";
const Color = require("color");

import { scale, getRandomInRange, getRandomRGBColor } from "./utils";
const TERP = require("../scripts/TERP.js");

const CC_MAX = 127;
const NOTE_SIZE_MIN = 15;
const NOTE_SIZE_MAX = 40;

class PitchRadialGradient extends LitElement {
    static get properties() {
        return {
            backgroundColor: { type: String },
            noteColor: { type: String },
            colorSystem: { type: String },
            colorValues: { type: Array },
            mixBlendMode: { type: String },
            width: { type: String },
            height: { type: String },
            widthDivision: { type: Number },
            heightDivision: { type: Number },
            left: { type: String },
            top: { type: String },
            bottom: { type: String },
            right: { type: String },
            position: { type: String },
            opacity: { type: Number },
            lowNote: { type: Number },
            highNote: { type: Number },
            startColor: { type: String },
            endColor: { type: String },
        };
    }

    constructor() {
        super();

        this.backgroundColor = "rgb(0, 0, 0)";
        this.noteColor = null;
        this.colorValues = [];
        this.mixBlendMode = "normal";
        this.width = null;
        this.height = null;
        this.widthDivision = 1;
        this.heightDivision = 1;
        this.left = "0%";
        this.top = "0%";
        this.bottom = null;
        this.colorOptions = {};
        // this.offset = 0;
        this.position = "relative";
        this.lowNote = 21;
        this.highNote = 70;
        this.startColor = "blue";
        this.endColor = "red";

        // this.container = null;
    }
    //-------------------------------------------------------------------------------
    handlePitch(note) {
        console.log("handlePitch()");
        if (note.number >= this.lowNote && note.number <= this.highNote) {
            this.note = note;
            this.container = this.shadowRoot.querySelector("#container");

            const element = document.createElement("div");
            element.id = `note${note.number}`;
            element.style = this.getNoteStyle(note);
            this.container.appendChild(element);

            setTimeout(() => {
                this.container.removeChild(element);
            }, 100);
        }
    }

    // handleNoteOff(e) {
    //     if (e.note.number >= this.lowNote && e.note.number <= this.highNote) {
    //         const element = this.shadowRoot.querySelector(
    //             `#note${e.note.number}`
    //         );

    //         if (element) {
    //             //console.log('element removed');
    //             for (let i = 0; i < this.activeNotes.length; i++) {
    //                 if (this.activeNotes[i].id === element.id) {
    //                     this.activeNotes.splice(i, 1);
    //                     break;
    //                 }
    //             }
    //             this.container.removeChild(element);
    //         } else {
    //             console.log("no element to remove");
    //         }
    //     }
    // }

    //-------------------------------------------------------------------------------
    // getResponsiveColor(note) {
    //     const responsiveColor = this.colorValues.map((val) => {
    //         if (val === -1) {
    //             if (this.colorSystem === "cmyk") {
    //                 return Math.floor(scale(note.number, 0, 127, 30, 100));
    //             }
    //             if (this.colorSystem === "lab") {
    //                 return Math.floor(scale(note.number, 0, 127, 30, 100));
    //             }
    //             if (this.colorSystem === "rgb") {
    //                 return Math.floor(scale(note.number, 0, 127, 150, 255));
    //             }
    //         } else {
    //             return val;
    //         }
    //     });

    //     const system = this.colorSystem;
    //     let rgbColor = "";

    //     if (system === "rgb") {
    //         rgbColor = responsiveColor;
    //     }

    //     if (system === "cmyk") {
    //         rgbColor = colorConvert.cmyk.rgb(responsiveColor);
    //     }
    //     if (system === "lab") {
    //         rgbColor = colorConvert.lab.rgb(responsiveColor);
    //     }
    //     return rgbColor;
    // }

    //-------------------------------------------------------------------------------
    // getRGBColor(responsiveColor) {
    //     const system = this.colorSystem;
    //     let rgbColor = "";

    //     if (system === "rgb") {
    //         rgbColor = responsiveColor;
    //     }

    //     if (system === "cmyk") {
    //         rgbColor = colorConvert.cmyk.rgb(responsiveColor);
    //     }
    //     if (system === "lab") {
    //         rgbColor = colorConvert.lab.rgb(responsiveColor);
    //     }
    //     return rgbColor;
    // }

    //-------------------------------------------------------------------------------
    getNoteColorResponsive(note) {
        if (!note) {
            return;
        }

        let system = this.colorSystem;
        let rgb = "";
        let responsiveColor;

        responsiveColor = this.colorValues.map((val) => {
            if (val === -1) {
                if (this.colorSystem === "cmyk") {
                    return Math.floor(scale(note.velocity, 0, 127, 0, 100));
                }
                if (this.colorSystem === "lab") {
                    return Math.floor(scale(note.velocity, 0, 127, 0, 100));
                }
                if (this.colorSystem === "rgb") {
                    return Math.floor(scale(note.velocity, 0, 127, 0, 255));
                }
            } else {
                return val;
            }
        });

        if (system === "rgb") {
            rgb = responsiveColor;
        } else if (system === "cmyk") {
            rgb = colorConvert.cmyk.rgb(responsiveColor);
        } else if (system === "lab") {
            rgb = colorConvert.lab.rgb(responsiveColor);
        }

        return `rgba(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, ${1})`;
    }

    //-------------------------------------------------------------------------------
    getNoteColor(note) {
        const factor = scale(note.velocity, 0, 127, 0, 1);
        const color = Color.hsl(this.startColor);
        const mixedColor = color.mix(Color.hsl(this.endColor), factor);
        return mixedColor;
    }

    //-------------------------------------------------------------------------------
    getNoteStyle(note) {
        console.log(`velocity: ${note.velocity} `);
        const noteSize = TERP.scale(
            note.velocity,
            0,
            127,
            NOTE_SIZE_MIN,
            NOTE_SIZE_MAX
        );
        let style = ``;
        const containerHeight = window
            .getComputedStyle(this.container)
            .height.slice(0, -2);
        const containerWidth = window
            .getComputedStyle(this.container)
            .width.slice(0, -2);

        style = `
    display: inline-block;
    position: absolute;
    width: ${containerWidth};
    height: ${containerHeight};
    background: radial-gradient(${
        this.noteColor ? this.noteColor : this.getNoteColor(note)
    } 2%, transparent ${noteSize}%);
    `;

        return style;
    }

    //-------------------------------------------------------------------------------
    updateNoteColors() {
        const noteSize = TERP.scale(
            this.note.velocity,
            0,
            127,
            NOTE_SIZE_MIN,
            NOTE_SIZE_MAX
        );

        const containerHeight = window
            .getComputedStyle(this.container)
            .height.slice(0, -2);
        const containerWidth = window
            .getComputedStyle(this.container)
            .width.slice(0, -2);
        this.activeNotes.forEach((element) => {
            // const note = { number: element.id.slice(4, element.id.length) };
            element.style = `
      display: inline-block;
      position: absolute;
      width: ${containerWidth};
      height: ${containerHeight};
      background: radial-gradient(${
          this.noteColor ? this.noteColor : this.getNoteColor(this.note)
      } 2%, transparent ${noteSize}%);
      transition: opacity .5s ease-out;
      opacity: 0;
      `;
        });
    }

    //-------------------------------------------------------------------------------
    render() {
        if (this.container) {
            this.updateNoteColors();
        }

        if (WebMidi.supported) {
            return html`
                <style>
                    :host {
                      margin: 0 auto;
                    }
                    #container {
                      position: ${this.position};
                      display: inline-block;
                      width: ${this.width
                        ? this.width
                        : `calc(100% / ${this.widthDivision})`};

                      height: ${this.height
                        ? this.height
                        : `calc(100% / ${this.heightDivision})`};

                      left: ${this.left};
                      top: ${this.top};
                      background: ${this.ccResponsive
                        ? ccColor
                        : this.backgroundColor};
                      mixblendmode: ${this.mixBlendMode};
                      opacity: ${this.opacity};
                </style>
                <div id="container"></div>
            `;
        } else {
            return html``;
        }
    }
}

customElements.define("pitch-radial-gradient", PitchRadialGradient);

// const r = TERP.scale(this.knobOneValue, 0, CC_MAX, 0, 255);
// const g = TERP.scale(this.knobTwoValue, 0, CC_MAX, 0, 255);
// const b = TERP.scale(this.knobThreeValue, 0, CC_MAX, 0, 255);
// this.lightness = colorConvert.rgb.lab([r, g, b])[0];
// const ccColor = `rgb(${r}, ${g}, ${b})`;
// this.updateNoteColors();
